export const tabElements = [
  {
    title: 'Ecosystem details',
    component: () => <></>,
  },
  {
    title: 'Customisation',
    component: () => <></>,
  },
  {
    title: 'Apps',
    component: () => <></>,
  },
];
